import PcCRUDBoilerPlate from "../../CRUDBoilerPlate/PcCRUDBoilerPlate";

function PcDILtNST({

    // parentChild props
    parentDBField,

    // common props
    api, screenTopicSingular, screenTopicPlural,
    
    // crud header props
    showTotalInHeading,
    
    // crud props
    allowCreate, allowUpdate, allowDelete,

    // extra action buttons
    extraActionButton, extraActionButtonChildren, extraActionButtonHandleClick,
    
    // field props
    //text props
    textDBField, textName,
    longTextDBField, longTextName,

    // select props
    selectApi, selectType, selectDBField, selectName
}) {
    return (
        <PcCRUDBoilerPlate

            // parentChild props
            parentDBField={parentDBField}
            
            // common props
            api={api}
            screenTopicSingular={screenTopicSingular}
            screenTopicPlural={screenTopicPlural}
            
            // crud header props
            showTotalInHeading={showTotalInHeading}

            // action button props
            extraActionButton={extraActionButton}
            extraActionButtonHandleClick={extraActionButtonHandleClick}
            extraActionButtonChildren={extraActionButtonChildren}
            
            // crud props
            allowCreate={allowCreate}
            allowUpdate={allowUpdate}
            allowDelete={allowDelete}
            
            // field props
            hasName
            hasImage
            hasDescription

            // long text props
            hasLongText
            longTextDBField={longTextDBField}
            longTextName={longTextName}
            
            // select props
            hasSelect
            selectApi={selectApi}
            selectType={selectType}
            selectDBField={selectDBField}
            selectName={selectName}

            //text props
            hasText
            textDBField={textDBField}
            textName={textName}
        />
    )
}

export default PcDILtNST